<template>
  <div>
    <el-form-item
      :label="field.name + '：'"
      label-width="110px"
      id="image-list"
    >
      <div class="item-list">
        <draggable v-model="config[field.key]">
          <el-row
            class="item"
            v-for="(item, index) in config[field.key]"
            :key="index"
            type="flex"
            justify="space-between"
          >
            <div
              class="link-name"
              v-text="config[field.key][index]['id']+'-'+config[field.key][index]['item_name']"
            ></div>
            <el-button
              size="small"
              @click="removeArticleItem(index)"
              class="del-btn"
              >删除</el-button
            >
          </el-row>
        </draggable>
        <el-button size="small" @click="openDialog">添加商品</el-button>
      </div>
    </el-form-item>
    <el-dialog
      title="请选择商品"
      :visible.sync="dialog.visible"
      @close="closeDialog"
    >
      <item-list
        :url="tableList.url"
        ref="item_list"
        @close="closeDialog"
        :multi="tableList.multi"
        :idList="idList"
        @unSelect="unSelect"
        @select="select"
        :pageData="pageData"
        @allSelect="allSelect"
      ></item-list>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.item-list {
  margin-top: -5px;
}
.item {
  cursor: pointer;
  padding: 5px 5px 5px 10px;
  &:hover {
    background: #f5f7fa;
  }
}
.link-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  padding-right: 20px;
}
.del-btn {
  height: 32px;
  margin-top: 4px;
}
</style>

<script>
import Util from "@/js/util";
import _ from "lodash";
import draggable from "vuedraggable";
export default {
  name: "tms-type-item",
  props: {
    field: {
      type: [Object, Array],
      required: true,
    },
    // config: {
    //   type: Object,
    //   default() {
    //     return {}
    //   }
    // },
    source: {
      type: String,
    },
    // pageData: {
    //   type: Object,
    //   default() {
    //     return {}
    //   }
    // }
  },
  data() {
    return {
      dialog: {
        visible: false,
      },
      linkNameList: {},
      currentIndex: 0,
      activeName: "normal",
      tableList: {
        url: "ec/c/item/get",
        multi: true,
      },
      sliceCount: 0,
    };
  },

  computed: {
    idList() {
      let list = [];
      this.config[this.field.key].map((val) => {
        list.push(val.id);
      });
      return list;
    },
    // 右侧组件数据初始化
    config() {
      if (this.source === "tmsPageConfig") {
        return this.$store.state.tms.pageData;
      }
      if (this.source === "tmsModuleConfig") {
        return this.$store.state.tms.config;
      }
      return this.$store.state.tms.customConfig;
    },
    pageData() {
      return this.$store.state.tms.pageData;
    },
  },

  components: {
    draggable,
  },

  created() {
    if (this.pageData.app_type == "seller") {
      console.log("选择卖家商品");
    } else {
      console.log("选择买家商品");
    }
  },

  methods: {
    openDialog() {
      this.dialog.visible = true;
    },
    removeArticleItem(index) {
      let row = this.config[this.field.key].splice(index, 1)[0];
      if (this.$refs.item_list) {
        this.$refs.item_list.removerIdList(row.id);
      }
    },
    handleUpload(src, index) {
      this.$set(this.config[this.field.key][index], image_url, src);
    },
    openDialog(index) {
      this.currentIndex = index;
      this.dialog.visible = true;
    },
    closeDialog() {
      this.dialog.visible = false;
    },
    select(row) {
      let item = _.cloneDeep(row);
      delete item.detail;
      item.cms_url = "/cms/page/biz/item.html?id=" + item.id;
      item.promotion_price = Util.filterPriceToFen(item.promotion_price);
      this.config[this.field.key].push(item);
    },
    unSelect(row, index) {
      this.config[this.field.key].splice(index, 1);
    },
    allSelect(value) {
      let section = _.cloneDeep(value);
      if (value.length > 0) {
        section.forEach((v, i) => {
          section[i].cms_url = "/cms/page/biz/item.html?id=" + v.id;
          section[i].promotion_price = Util.filterPriceToFen(v.promotion_price);
          this.sliceCount++;
        });
        section.forEach((v, i) => {
          if (!this.config.link_data[i]) {
            this.config[this.field.key].push(v);
          }
        });
      } else {
        this.config[this.field.key].splice(-this.sliceCount);
        this.sliceCount = 0;
      }
    },
  },
};
</script>
